import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import 'dayjs/locale/pt-br';

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.locale('pt-br');

export const rules = {
  description: [{ required: true }],
  stage: [{ required: true }],
  urgencyDegree: [{ required: true }],
  occurredAt: [
    {
      required: true,
      validator: (_: any, value: any) => {
        const date = dayjs();

        if (dayjs(value).isAfter(date)) {
          return Promise.reject(new Error('A data informada é inválida'));
        }

        return Promise.resolve();
      },
    },
  ],
  patrimonyId: [{ required: true }],
  operatorId: [{ required: true }],
  cellId: [{ required: true }],
  status: [{ required: true }],
};
